import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';

const RFPPipelineFilters = [
	{
		displayName: 'Draft',
		name: 'draft',
		filter: { status: 'draft' },
		icon: 'icons8-edit',
		iconStyle: { color: '#4a1e87' },
	},
	{
		displayName: 'Active',
		name: 'active',
		filter: { status: 'active' },
		icon: 'icons8-wrench',
		iconStyle: { color: STOPLIGHT_COLORS.yellowGreen },
	},
	{
		displayName: 'Awarded',
		name: 'award',
		filter: { status: 'award' },
		icon: 'icons8-approve',
		iconStyle: { color: STOPLIGHT_COLORS.pureYellow },
	},
	{
		displayName: 'Closed',
		name: 'closed',
		filter: { status: 'closed' },
		icon: 'icons8-cancel',
		iconStyle: { color: STOPLIGHT_COLORS.pureRed },
	},
];

export default RFPPipelineFilters;
